import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';
import { memo } from 'react';

const TestQuestionInstructionsNodeView: React.FC<ReactNodeViewProps> = ({ decorations }) => {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div className="mb-2">
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
};

export default memo(TestQuestionInstructionsNodeView);
